const getLinearTickInterval = ({dimensionDataType, series}) => {
    // sometimes we have years in integer, AB#899
    // guess the case and set appropriate tick interval of 1
    const likelyToBeYear = dimensionDataType === "Int" && Number.isInteger(series[0].data[0][0]) && series[0].data[0][0] >= 1970 && series[0].data[0][0] <= 2050;
    if (likelyToBeYear) {
        return {tickInterval: 1};
    }
};
exports.getLinearTickInterval = getLinearTickInterval;
